import axios from "axios";

class ContactForm {
    constructor() {
        this.contactForm = document.querySelector("#regularContactForm");
        this.businessForm = document.querySelector("#businessContactForm");
        this.subject = document.querySelector(".default-input__select");
        this.errorNotice = document.querySelector(".contact-form__notice");
        this.formValid = false;
;
        this.events();
    }

    // 2. events
    events() {
        if (this.contactForm) {
            this.contactForm.addEventListener("submit", (e) => {
                e.preventDefault();
                this.validation(this.contactForm);
                this.formValid ? this.sendEmail(this.contactForm) : "";
            });
        }
        if (this.businessForm) {
            this.businessForm.addEventListener("submit", (e) => {
                e.preventDefault();
                this.validation(this.businessForm);
                this.formValid ? this.sendEmail(this.businessForm) : "";
            });
        }
    }

    validation(form) {
        const validationObj = [];
        Array.from(form.elements).forEach((el, key) => {
            if (!el.value) {
                el.parentNode.classList.add('error')
                el.classList.add("error");
                if (el.classList.contains("btn")) {
                    validationObj[key] = 1;
                } else {
                    validationObj[key] = 0;
                }
            } else if (el.name === "contact" && el.value && !this.validateContactField(el.value)) {
                validationObj[key] = 0;
                el.classList.add("error");
            } else if (el.name === "message" && el.value && !this.validateMessage(el.value)){
                validationObj[key] = 0;
                el.classList.add("error");
            }
            else {
                el.parentNode.classList.remove("error");
                el.classList.contains("error") ? el.classList.remove("error") : "";
            }


            if (validationObj.includes(0)) {
                this.errorNotice.classList.add("contact-form__notice--error");
                this.formValid = false;
            } else {
                if (
                    this.errorNotice.classList.contains(
                        "contact-form__notice--error"
                    )
                ) {
                    this.errorNotice.classList.remove(
                        "contact-form__notice--error"
                    );
                }
                this.formValid = true;
            }
        });
    }

    sendEmail(form) {
        const formValues = document.forms[form.id];
        const formData = new FormData(formValues);
        if (form === this.businessForm) {
            formData.append("type", "business");
        } else {
            formData.append("type", "regular");
        }
        formData.append("action", "sendEmailFromContact");
        axios
            .post(ajax.ajax_url, formData)
            .then((res) => {
                form.reset();
                this.errorNotice.innerHTML = JSON.parse(res.data.data);
                this.errorNotice.classList.add("contact-form__notice--done");
            })
            .catch((err) => {
            });
    }

    validateContactField(value) {
        const mailFormat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|([\+\s0-9]{9,})+$/;
        return mailFormat.test(value);
    }

    validateMessage(value){
        if (value.length > 9) return true
        else return false
        // const messageFormat = /^([\w0-9]{10,})$/;
        // return messageFormat.test(value);
    }
}

export default ContactForm;
